// extracted by mini-css-extract-plugin
module.exports = {"Tab":"OnHandItemTab_Tab__f0gA3"};